import { useEffect, useState } from "react";
import { Search, Store, Loader2 } from "lucide-react";
import { api, productImageUrl } from "@/lib/api";

export default function BrandsSection({ onSelectBrand }) {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api
      .get("/brands")
      .then(({ data }) => setBrands(data))
      .finally(() => setLoading(false));
  }, []);

  const filtered = brands.filter((b) =>
    b.name.toLowerCase().includes(query.trim().toLowerCase())
  );

  return (
    <div data-testid="brands-section">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-800">Our Brands</h2>
          <p className="text-sm text-slate-500">
            {brands.length} brands available · tap a brand to see its products
          </p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="brand-search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search brands..."
            className="w-full rounded-lg border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 className="h-6 w-6 animate-spin text-blue-500" />
        </div>
      ) : filtered.length === 0 ? (
        <p className="py-12 text-center text-sm text-slate-400">No brands match "{query}".</p>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {filtered.map((b) => (
            <button
              key={b.id}
              data-testid={`brand-card-${b.id}`}
              onClick={() => onSelectBrand(b.name)}
              className="group flex flex-col overflow-hidden rounded-xl border border-blue-100 bg-white shadow-sm transition hover:-translate-y-0.5 hover:border-blue-300 hover:shadow-md"
            >
              <div className="flex flex-1 items-center justify-center bg-blue-50/50 p-4 transition group-hover:bg-blue-50">
                {b.logo_path ? (
                  <img
                    src={productImageUrl(b.logo_path, "sm")}
                    srcSet={`${productImageUrl(b.logo_path, "sm")} 1x, ${productImageUrl(b.logo_path, "md")} 2x`}
                    alt={b.name}
                    loading="lazy" decoding="async"
                    className="h-20 w-full object-contain"
                    draggable={false}
                  />
                ) : (
                  <span className="grid h-20 w-full place-items-center text-blue-300 transition group-hover:text-blue-500">
                    <Store className="h-10 w-10" />
                  </span>
                )}
              </div>
              <span className="border-t border-slate-100 px-3 py-2.5 text-center text-sm font-semibold text-slate-700">
                {b.name}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
